import { render } from "./DeletePartnerButtonView.vue?vue&type=template&id=a6f8ba64&scoped=true"
import script from "./DeletePartnerButtonView.vue?vue&type=script&lang=js"
export * from "./DeletePartnerButtonView.vue?vue&type=script&lang=js"

import "./DeletePartnerButtonView.vue?vue&type=style&index=0&id=a6f8ba64&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f8ba64"]])

export default __exports__